var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainDiv"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.img}}),_c('div',[_c('p',{staticClass:"txt"},[_vm._v(" "+_vm._s(_vm.txt)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }